/** Indian-grouped rupees: 125000 → ₹1,25,000. */
export function inr(amount: number): string {
  return `₹${Math.round(amount).toLocaleString('en-IN')}`;
}

/** Indian-grouped count: 125000 → 1,25,000. */
export function count(n: number): string {
  return n.toLocaleString('en-IN');
}

/** Whole-number percentage of a total, 0 when the total is 0. */
export function pct(part: number, total: number): number {
  return total > 0 ? Math.round((part / total) * 100) : 0;
}

/** Up to two initials from a name, for avatar tiles. */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

/** The page numbers a pager shows: at most `span` buttons around the current page. */
export function pageWindow(page: number, pages: number, span = 7): number[] {
  if (pages <= span) return Array.from({ length: pages }, (_, i) => i + 1);
  const half = Math.floor(span / 2);
  const start = Math.min(Math.max(1, page - half), pages - span + 1);
  return Array.from({ length: span }, (_, i) => start + i);
}

/** Date and time for logs and sessions, in the reader's language (Indian conventions). */
export function dateTime(iso: string, lang: string): string {
  return new Date(iso).toLocaleString(lang === 'ml' ? 'ml-IN' : 'en-IN', { dateStyle: 'medium', timeStyle: 'short' });
}

/** "2026-11" → "Nov 2026" (English) or the Malayalam month name. */
export function monthLabel(period: string, lang: string): string {
  const [y, m] = period.split('-').map(Number) as [number, number];
  return new Intl.DateTimeFormat(lang === 'ml' ? 'ml-IN' : 'en-IN', { month: 'short', year: 'numeric', timeZone: 'UTC' }).format(Date.UTC(y, m - 1, 1));
}

/** Today's date in Indian time, "2026-11-04". */
export function todayIst(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
}
